<div class="opacity-container-mini">
  <label class="label-container">{{ title }}</label>
  <div class="slider-with-labels">
    <div class="slider-labels">
      <span>0</span>
      <span>100</span>
      <div
        #currentValue
        class="current-value"
        [attr.data-edge]="initialValue === 0 ? 'left' : initialValue === 100 ? 'right' : null"
        [style.--thumb-position]="initialValue + '%'"
      >
        {{ initialValue }}
      </div>
    </div>
    <input
      #slider
      type="range"
      class="opacity-slider-mini"
      min="0"
      max="100"
      step="1"
      [(ngModel)]="initialValue"
      (input)="onValueChange($event.target.value, slider, currentValue)"
      [style.--fill-percent]="initialValue + '%'"
      title="Opacity: {{ initialValue }}"
    />
  </div>
</div>
